import React from 'react';
import PropTypes from 'prop-types';

const STEP_LABELS = { 1: 'Tu empresa', 2: 'Tu plan', 3: 'Tu perfil' };

const DoneIcon = () => (
  <svg width="12" height="12" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M20 6 9 17l-5-5" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

// Step indicator (1 - 2 - 3 · PASO N · LABEL), Claude Design language:
// done = green check, current = brand gradient, pending = pale lavender.
const OnboardingStepper = ({ current }) => (
  <div className="pf-stepper" aria-label={`Paso ${current} de 3`}>
    {[1, 2, 3].map(step => {
      let stateClass = 'pf-stepper__dot--pending';
      if (step < current) stateClass = 'pf-stepper__dot--done';
      if (step === current) stateClass = 'pf-stepper__dot--current';

      return (
        <React.Fragment key={step}>
          {step > 1 && <span className={`pf-stepper__line ${step <= current ? 'pf-stepper__line--active' : ''}`} />}
          <span className={`pf-stepper__dot ${stateClass}`}>{step < current ? <DoneIcon /> : step}</span>
        </React.Fragment>
      );
    })}
    <span className="pf-stepper__label">
      Paso {current} · {STEP_LABELS[current]}
    </span>
  </div>
);

OnboardingStepper.propTypes = {
  current: PropTypes.oneOf([1, 2, 3]).isRequired
};

export default OnboardingStepper;
